import { BaseModalProps, Modal } from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { TicketForm, TicketFormData, TicketAppointment } from './TicketForm';
import { CreateTicketDto } from '@/lib/api/tickets';

export interface CreateTicketModalProps extends BaseModalProps {
  onCreate: (data: CreateTicketDto) => Promise<boolean>;
  isCreating: boolean;
}

export function CreateTicketModal({
  open,
  onOpenChange,
  onCreate,
  isCreating,
}: CreateTicketModalProps) {
  const { t } = useTranslation();

  const handleSubmit = async (data: TicketFormData & { appointments: TicketAppointment[] }) => {
    const success = await onCreate({
      number: data.number,
      title: data.title,
      userId: data.userId,
      date: data.date,
      contractId: data.contractId,
      appointments: data.appointments.map((appointment) => ({
        date: appointment.date.toISOString(),
        workedTime: appointment.workedTime,
        isDoubleDebited: appointment.isDoubleDebited,
        userId: appointment.userId,
      })),
    });

    if (success) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={t('tickets.createModal.title')}>
      <TicketForm
        mode="create"
        onSubmit={handleSubmit}
        isLoading={isCreating}
        onCancel={handleCancel}
      />
    </Modal>
  );
}
